import {
  Breadcrumb,
  Button,
  Col,
  ConfigProvider,
  Empty,
  Image,
  Input,
  Layout,
  message,
  Popconfirm,
  Radio,
  Row,
  Select,
  Tabs,
  Upload,
} from 'antd'
import OAMSider from '../oam-sider'
import { Content } from 'antd/lib/layout/layout'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import css from './oam-task-edit.module.less'
import GlobalCss from '@/global.module.less'
import { sendHttpPostRequest } from '@/api/http-request'
import Cookies from 'js-cookie'
import TextArea from 'antd/lib/input/TextArea'
import { FileList } from '../dataset/detail/FileList'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  CloseOutlined,
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import PublicTipModal from '@/pages/components/PublicTipModal/PublicTipModal'
import MonacoEditor from 'react-monaco-editor'
import exerciseStyles from './oam-task.module.less'
import MountDatasetToTaskModal from './components/MountDatasetToTaskModal/MountDatasetToTaskModal'
import * as constants from '@/constants/constants'
import zhCN from 'antd/lib/locale/zh_CN'
import { useHistory, useLocation } from 'react-router-dom'

interface Props {}

const { Option } = Select

export const OAMTaskEdit: React.FC<Props> = (props) => {
  const exerciseInfoReducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_PROPERTY':
        return { ...state, [action.payload.key]: action.payload.value }
      case 'UPDATE_ALL_OBJ':
        return action.payload
      default:
        return state
    }
  }

  const editorOptions = {
    selectOnLineNumbers: true,
    fontSize: 14,
    minimap: { enabled: false },

    lineDecorationsWidth: 5,
    lineNumbersMinChars: 2, //默认至少显示多少行号
    quickSuggestions: false,
    overviewRulerBorder: false,
    automaticLayout: true,
    formatOnPaste: true,
  }

  const initialDatasetInfo = {
    title: '',
    description: '',
    mounted_datasets: [],
  }

  const exerciseId = parseInt(window.location.search.split('=')[1]) // 习题的ID

  const [exercise, dispatch] = useReducer(
    exerciseInfoReducer,
    initialDatasetInfo
  )
  const [activeTabKey, setActiveTabKey] = useState('1')
  const [taskDatasetInfo, setTaskDatasetInfo] = useState<any>()
  const [activeMontedDatasetInfo, setActiveMontedDatasetInfo] = useState<any>(
    exercise?.mounted_datasets[0]
  )
  const [addDatasetModalVis, setAddDatasetModalVis] = useState(false)
  const [actionDataset, setActionDataset] = useState<any>()
  const [unMountDatasetModalVis, setUnMountDatasetModalVis] = useState(false)
  const actionDatasetIndex = useRef(0)

  const [editorLanguage, setEditorLanguage] = useState('python') // 编辑框默认语言
  const [images, setImages] = useState([] as any[]) // 已绑定图片状态变量
  const editMode = useLocation().pathname.includes('edit')
  const history = useHistory()

  // 查询任务详情
  const queryExerciseInfo = () => {
    sendHttpPostRequest(
      'exercise/api/oam_query_task_by_id/',
      { exercise_id: exerciseId, sessionid: Cookies.get('sessionid') },
      (res) => {
        if (res.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_task'
        } else if (res.code == 0) {
          // 成功
          console.log(res)
          dispatch({
            type: 'UPDATE_ALL_OBJ',
            payload: res.exercise_info,
          })
          setImages(res.exercise_info.images)
          // setActiveMontedDatasetInfo(
          //   res.exercise_info.mounted_datasets[0]
          // )
          queryTaskDatasetInfo(res.exercise_info.dataset_id)
        } else if (res.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_task'
        } else {
          message.error(res.message)
        }
      }
    )
  }

  // 查询任务数据集详情
  const queryTaskDatasetInfo = (datasetId?: any) => {
    let data = {
      dataset_id: datasetId || exercise?.dataset_id,
    }
    sendHttpPostRequest('dataset/api/oam_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setTaskDatasetInfo(res.query_info)
      } else {
        message.error(res.message)
      }
    })
  }

  useEffect(() => {
    if (editMode) {
      setActiveMontedDatasetInfo(exercise?.mounted_datasets[0])
      queryExerciseInfo()
    }
  }, [])

  // 文本类型字段改变
  const onTextChange = (key: string, event: any) => {
    // exercise[key] = event.target.value
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key, value: event.target.value },
    })
  }

  // 任务类型改变
  const onTypeChange = (e: any) => {
    const newType = e.target.value
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key: 'type', value: parseInt(newType) },
    })
  }

  // 是否需要echarts渲染改变
  const onEchartsNeedChange = (e: any) => {
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key: 'need_echarts_render', value: parseInt(e.target.value) },
    })
  }

  // 是否需要动画视频渲染改变
  const onAnimationNeedChange = (e: any) => {
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key: 'need_animation', value: parseInt(e.target.value) },
    })
  }
  //题目说明改变
  const onStepsChange = (event: any) => {
    // exercise.steps = event.target.value
    //setMdSteps(event.target.value)
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key: 'steps', value: event.target.value },
    })
  }

  //用户编辑代码发生改变
  const onCodeChange = (key: string, newValue: string, event: any) => {
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key, value: newValue },
    })
  }

  // 语言改变
  const languageChange = (key: any, object: any) => {
    const languageKey = parseInt(key)
    let languageStr = 'python'
    if (languageKey == 3 || languageKey == 4) {
      languageStr = 'r'
    } else if (languageKey == 5) {
      languageStr = 'mysql'
    } else if (languageKey == 6) {
      languageStr = 'java'
    } else if (languageKey == 7) {
      languageStr = 'scala'
    } else if (languageKey == 8) {
      languageStr = 'spark'
    }
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key: 'language', value: languageKey },
    })
    dispatch({
      type: 'UPDATE_PROPERTY',
      payload: { key: 'language_str', value: object['children'] },
    })
    setEditorLanguage(languageStr)
  }

  const queryMountedDatasetInfo = (id) => {
    let data = {
      dataset_id: id,
    }
    sendHttpPostRequest('dataset/api/oam_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setActiveMontedDatasetInfo({
          ...res.query_info,
          dataset_id: res.query_info.id,
        })
      } else {
        message.error(res.message)
      }
    })
  }

  const onMenuClick = (dataset) => {
    queryMountedDatasetInfo(dataset?.dataset_id)
  }

  const unMountDataset = (dataset, index) => {
    setActionDataset(dataset)
    actionDatasetIndex.current = index
    setUnMountDatasetModalVis(true)
  }

  const onCancelSave = () => {
    queryExerciseInfo()
  }
  const onSave = () => {
    if (!exercise.title) {
      message.error('请输入任务名称！')
      return
    }
    const requestParams = {
      exercise_id: exercise.id,
      title: exercise.title,
      remarks: exercise.remarks,
      type: exercise.type,
      default_code: exercise.default_code,
      steps: exercise.steps,
      preset_code: exercise.preset_code,
      language: exercise.language,
      judgement_code: exercise.judgement_code,
      reference_answer: exercise.reference_answer,
      task_steps: exercise.task_steps,
      task_conclude: exercise.task_conclude,
      video: exercise.video,
      need_animation: exercise.need_animation,
      need_echarts_render: exercise.need_echarts_render,
      image_list: JSON.stringify(images),
    }

    if (editMode) {
      sendHttpPostRequest(
        'exercise/api/oam_update_task/',
        requestParams,
        (res) => {
          if (res.code == 0) {
            message.success('保存成功！')
            window?.opener?.location.reload()
            // console.log();
          } else {
            message.error(res.message)
          }
        }
      )
    } else {
      sendHttpPostRequest(
        'exercise/api/oam_create_task/',
        requestParams,
        createTaskCallback
      )
    }
  }

  /**
   * 创建任务回调
   * @param response
   */
  const createTaskCallback = (response: any) => {
    message.destroy()
    if (response.code == 100) {
      // 没登录
      window.location.href = '/login'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/login'
    } else if (response.code == 0) {
      if (response.exercise_id) {
        history.push(`/oam_task_edit?task_id=${response.exercise_id}`)
      } else {
        message.error(response.message)
      }
    }
  }

  const MenuItem = (props: any) => {
    const { dataset, onClick, index } = props

    return (
      <Row
        onClick={onClick}
        className={
          css.menuItem +
          ' ' +
          (dataset.dataset_id == activeMontedDatasetInfo?.dataset_id ||
          dataset.dataset_id == activeMontedDatasetInfo?.id
            ? css.activeMenuItem
            : '')
        }
        align={'top'}
        justify={'space-between'}
        wrap={false}
      >
        <Col>
          <Row align={'top'} justify={'start'} style={{ gap: '10px' }}>
            <Col>
              <span
                style={{
                  color: '#4f46e5',
                }}
                className="iconfont icon-datafull"
              ></span>
            </Col>
            <Col>
              <div
                className={css.dtstTitle + ' ' + GlobalCss.oneLineTextOverflow}
                style={{ maxWidth: '340px' }}
              >
                {dataset.title}
              </div>
              <CopyToClipboard
                text={'../' + dataset?.base_path}
                onCopy={() => {
                  message.success('路径已复制')
                }}
              >
                <span className={css.datasetBasePath}>
                  {dataset?.base_path}
                </span>
              </CopyToClipboard>
            </Col>
          </Row>
        </Col>
        <Col>
          <div
            className={GlobalCss.btnBox}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              unMountDataset(dataset, index)
            }}
          >
            <CloseOutlined className={css.deleteIcon} />
          </div>
        </Col>
      </Row>
    )
  }
  // 上传数据集传参
  const uploadData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
    // exercise_id: exerciseId,
    type: 1,
    source: 1,
  }

  // 上传图片
  const uploadImageProps = {
    accept: '.png,.jpg,.gif,.jpeg,',
    name: 'image',
    multiple: false,
    showUploadList: false,
    data: uploadData,
    action: constants.BACKEND_API_URL + 'exercise/api/oam_upload_task_image',
    onChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.code == 0) {
          message.success(`图片${info.file.name}文件上传成功！`)
          // if (!info.file.response.update_only) {
          images.push({
            path: info.file.response.data.path,
            name: info.file.response.data.name,
          })
          setImages(JSON.parse(JSON.stringify(images)))
          //addNewImage(info.file.response);
          // }
        } else {
          if (info.file.response.code == -100) {
            // 未登录
            const localPath = window.location.href.split(
              window.location.host
            )[1]
            window.location.href = `/oam_login?next=${localPath}`
          } else if (info.file.response.code == -501) {
            // 权限不足
            const localPath = window.location.href.split(
              window.location.host
            )[1]
            window.location.href = `/oam_login?next=${localPath}`
          } else {
            message.error(info.file.response.message)
          }
        }
      } else if (status === 'error') {
        message.error(`图片${info.file.name}文件上传失败了:(`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  // 删除图片回调
  const deleteImageCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      const localPath = window.location.href.split(window.location.host)[1]
      window.location.href = `/oam_login?next=${localPath}`
    } else if (response.code == -501) {
      // 权限不足
      const localPath = window.location.href.split(window.location.host)[1]
      window.location.href = `/oam_login?next=${localPath}`
    } else if (response.code == 0) {
      message.success(`图片${response.image_name}删除成功！`)
      // const newImages = images.filter((item) => item.id !== response.image_id)
      // setImages(newImages)
      //document.getElementById("image-" + response.image_id)!.remove();
    } else {
      message.error(response.message)
    }
  }

  // 删除图片
  const deleteImage = (index: number) => {
    images.splice(index, 1)
    setImages([...images])
    // sendHttpPostRequest(
    //   'exercise/api/delete_task_image/',
    //   {
    //     sessionid: Cookies.get('sessionid'),
    //     exercise_id: exerciseId,
    //     image_name: imageName,
    //   },
    //   deleteImageCallback
    // )
  }

  return (
    <Layout style={{ minHeight: '100vh', position: 'relative' }}>
      <OAMSider keys={['5']} openKeys={[]} />

      <Content
        style={{
          backgroundColor: '#fff',
          borderRadius: 5,
          minWidth: 500,
          margin: 50,
          // paddingTop: '20px',
        }}

        
      >
        <Breadcrumb style={{ marginLeft: 0, float: 'left', marginTop: -35 }}>
          <Breadcrumb.Item>
            <a href="/oam_task">任务列表</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span style={{ fontWeight: 500 }}> 任务编辑 </span>
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className={css.tabContain}>
          {activeTabKey == '3' && (
            <Button
              onClick={() => {
                setAddDatasetModalVis(true)
              }}
              className={GlobalCss.defBtn}
              style={{
                position: 'absolute',
                right: 60,
                top: 60,
                zIndex: 1000,
              }}
            >
              添加数据集
            </Button>
          )}
          <Tabs
            activeKey={activeTabKey}
            onChange={(key) => {
              if (key == '3') {
                setActiveMontedDatasetInfo(exercise?.mounted_datasets[0])
              }
              setActiveTabKey(key)
            }}
          >
            <Tabs.TabPane tab="任务信息" key="1">
              <div className={css.tabForm}>
                <Row
                  justify="start"
                  align="middle"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle} >
                    任务名称
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Input
                      placeholder="请输入任务名称"
                      required={true}
                      value={exercise?.title}
                      onChange={onTextChange.bind(this, 'title')}
                      style={{ width: '100%' }}
                    />
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="middle"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    任务类型
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Radio.Group
                      style={{ width: 500, textAlign: 'left' }}
                      onChange={onTypeChange}
                      // defaultValue={exercise?.type}
                      value={exercise?.type}
                    >
                      <Radio value={1}>实训</Radio>
                      <Radio value={6}>纯讲义</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="top"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    任务语言
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Select
                      value={exercise?.language_str}
                      style={{ borderRadius: 6, width: 150, textAlign: 'left' }}
                      onChange={languageChange}
                      disabled={true}
                    >
                      <Option value="10">python3.8</Option>
                      <Option value="9">pyspark</Option>
                    </Select>
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="middle"
                  wrap={false}
                  style={{ marginBottom: 20, gap: '15px' }}
                >
                  <Col flex="135px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    是否需要Echarts渲染
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Radio.Group
                      style={{
                        width: 500,
                        textAlign: 'left',
                        display: 'flex',
                        gap: '50px',
                      }}
                      onChange={onEchartsNeedChange}
                      // defaultValue={exercise?.type}
                      value={exercise?.need_echarts_render}
                    >
                      <Radio value={1}>是</Radio>
                      <Radio value={2}>否</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="middle"
                  wrap={false}
                  style={{ marginBottom: 20, gap: '10px' }}
                >
                  <Col flex="140px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    是否需要动画视频渲染
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Radio.Group
                      style={{
                        width: 500,
                        textAlign: 'left',
                        display: 'flex',
                        gap: '50px',
                      }}
                      onChange={onAnimationNeedChange}
                      // defaultValue={exercise?.type}
                      value={exercise?.need_animation}
                    >
                      <Radio value={1}>是</Radio>
                      <Radio value={2}>否</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="middle"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    任务视频
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Input
                      placeholder="请输入任务视频地址"
                      required={true}
                      value={exercise?.video}
                      onChange={onTextChange.bind(this, 'video')}
                      style={{ width: '100%' }}
                    />
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="top"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    任务说明
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <TextArea
                      placeholder="请输入任务说明"
                      style={{width: '100%' }}
                      autoSize={{ minRows: 2 }}
                      value={exercise?.steps}
                      onChange={onStepsChange}
                    />
                  </Col>
                </Row>
                <Row
                  gutter={[8, 8]}
                  justify="start"
                  align="middle"
                  style={{ marginBottom: 10 }}
                >
                  <Col span={24} style={{ textAlign: 'right' }}>
                    <span style={{ fontSize: 12, color: '#00000073' }}>
                      请上传以字母、数字命名的png,jepg,jpg,gif等格式的图片{' '}
                    </span>
                    <Upload {...uploadImageProps}>
                      <div>
                        <Button
                          size="small"
                          type="default"
                          style={{ width: 100, borderRadius: 20 }}
                        >
                          <UploadOutlined /> 传图
                        </Button>
                      </div>
                    </Upload>
                  </Col>
                </Row>

                <Row
                  gutter={[8, 8]}
                  justify="start"
                  align="middle"
                  style={{ marginBottom: images?.length > 0 ? 10 : 0 }}
                >
                  <Col flex="150px"></Col>
                  <Col
                    flex="auto"
                    style={{
                      borderRadius: 6,
                      borderStyle: 'dashed',
                      borderWidth: images?.length > 0 ? 1 : 0,
                      borderColor: '#e9e9e9',
                      textAlign: 'left',
                    }}
                  >
                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                      <ConfigProvider locale={zhCN}>
                        <Row justify="start" align="middle" gutter={[10, 10]}>
                          {images?.map((image: any, i) => {
                            return (
                              <Col key={image + i}>
                                <div>
                                  <Popconfirm
                                    placement="top"
                                    title={'确认删除图片' + image.name + '吗？'}
                                    okText="确认"
                                    cancelText="取消"
                                    onConfirm={(e) => {
                                      deleteImage(i)
                                    }}
                                    onCancel={() => {
                                      return
                                    }}
                                  >
                                    <DeleteOutlined
                                      className={exerciseStyles.iconbuttonsdel}
                                    />
                                  </Popconfirm>

                                  <Image
                                    width={360}
                                    height={270}
                                    src={constants.BACKEND_URL + image.path + image.name}
                                  />
                                </div>
                              </Col>
                            )
                          })}
                        </Row>
                      </ConfigProvider>
                    </div>

                    <div className={'new-image'}></div>
                    <div id={'add-image-div'}></div>
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="top"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    任务步骤
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>

                    <div style={{marginBottom:8}}>注意: 步骤用-+*表示列表，不用序号列表</div>
                    <TextArea
                      placeholder="请输入任务步骤"
                      autoSize={{ minRows: 3 }}
                      required={true}
                      value={exercise?.task_steps}
                      onChange={onTextChange.bind(this, 'task_steps')}
                      style={{ borderRadius: 8, width: '100%' }}
                    />
                  </Col>
                </Row>
                <Row
                  justify="start"
                  align="top"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }} className={css.editTitle}>
                    任务总结
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <TextArea
                      placeholder="请输入任务总结"
                      autoSize={{ minRows: 3 }}
                      required={false}
                      value={exercise?.task_conclude}
                      onChange={onTextChange.bind(this, 'task_conclude')}
                      style={{ borderRadius: 8, width: '100%' }}
                    />
                  </Col>
                </Row>

                <Row
                  justify="start"
                  align="top"
                  style={{ marginBottom: 20, gap: '50px' }}
                >
                  <Col flex="100px" style={{ textAlign: 'left' }}>
                    备注(选填)
                  </Col>
                  <Col flex="auto" style={{ textAlign: 'left' }}>
                    <TextArea
                      placeholder="请输入题目备注"
                      autoSize={{ minRows: 2, maxRows: 3 }}
                      value={exercise?.remarks}
                      onChange={onTextChange.bind(this, 'remarks')}
                      style={{ width: '100%', borderRadius: 8 }}
                    />
                  </Col>
                </Row>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="任务数据集" key="2" disabled={!editMode}>
              {taskDatasetInfo && (
                <FileList
                  actionPath={'/oam_task_edit?task_id=' + exerciseId}
                  datasetInfo={taskDatasetInfo}
                  source="oam"
                  dataset_id={taskDatasetInfo?.id}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab="挂载数据集" key="3" disabled={!editMode}>
              {exercise?.mounted_datasets?.length > 0 ? (
                <Row className={css.montedContain} wrap={false}>
                  <Col className={css.montedMenu} flex={'440px'}>
                    {exercise?.mounted_datasets?.map((dtst, i) => {
                      return (
                        <MenuItem
                          key={dtst.dataset_id}
                          dataset={dtst}
                          onClick={onMenuClick.bind(this, dtst)}
                          index={i}
                        />
                      )
                    })}
                  </Col>
                  <Col className={css.montedTable} flex={'auto'}>
                    {activeMontedDatasetInfo && (
                      <FileList
                        actionPath={'/oam_task_edit?task_id=' + exerciseId}
                        datasetInfo={activeMontedDatasetInfo}
                        mode={'monted'}
                        source="oam"
                        dataset_id={activeMontedDatasetInfo?.dataset_id}
                      />
                    )}
                  </Col>
                </Row>
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '500px',
                    lineHeight: '500px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <span style={{ color: '#999999' }}>
                        暂无数据 ，点击
                        <span
                          onClick={() => setAddDatasetModalVis(true)}
                          className={GlobalCss.link + ' ' + GlobalCss.hlText}
                        >
                          添加数据集
                        </span>
                      </span>
                    }
                  />
                </div>
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab="代码" key="4">
              <div className={css.codeTabs}>
                <Tabs>
                  <Tabs.TabPane tab="预设代码" key="4-1">
                    <MonacoEditor
                      className={exerciseStyles.codeEditor}
                      height="600px"
                      language={editorLanguage}
                      theme="vs"
                      value={exercise?.preset_code}
                      options={editorOptions}
                      onChange={onCodeChange.bind(this, 'preset_code')}
                      //editorDidMount={editorDidMount}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="默认代码" key="4-2">
                    <MonacoEditor
                      className={exerciseStyles.codeEditor}
                      width="100%"
                      height="600px"
                      language={editorLanguage}
                      theme="vs" //"vs" | "vs-dark" | "hc-black"
                      value={exercise?.default_code}
                      options={editorOptions}
                      onChange={onCodeChange.bind(this, 'default_code')}
                      //editorDidMount={editorDidMount}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="判定代码" key="4-3">
                    <MonacoEditor
                      className={exerciseStyles.codeEditor}
                      width="100%"
                      height="600px"
                      language={editorLanguage}
                      theme="vs" //"vs" | "vs-dark" | "hc-black"
                      value={exercise?.judgement_code}
                      options={editorOptions}
                      onChange={onCodeChange.bind(this, 'judgement_code')}
                      //editorDidMount={editorDidMount}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="参考代码" key="4-4">
                    <MonacoEditor
                      className={exerciseStyles.codeEditor}
                      width="100%"
                      height="600px"
                      language={editorLanguage}
                      theme="vs" //"vs" | "vs-dark" | "hc-black"
                      value={exercise?.reference_answer}
                      options={editorOptions}
                      onChange={onCodeChange.bind(this, 'reference_answer')}
                      //editorDidMount={editorDidMount}
                    />
                  </Tabs.TabPane>
                </Tabs>
              </div>
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Content>
      {(activeTabKey == '1' || activeTabKey == '4') && (
        <Row
          align={'middle'}
          justify={'center'}
          className={css.createFooter}
          style={{ gap: '36px' }}
        >
          <Col>
            <Button style={{width:100, height:36}} className={GlobalCss.defBtn} onClick={onCancelSave}>
              取消
            </Button>
          </Col>
          <Col>
            <Button  style={{width:100, height:36}} type={'primary'} onClick={onSave}>
              保存
            </Button>
          </Col>
        </Row>
      )}
      <PublicTipModal
        handleCancel={() => {
          setUnMountDatasetModalVis(false)
        }}
        handleOk={() => {
          let data = {
            exercise_id: exerciseId,
            dataset_id_list: JSON.stringify([actionDataset.dataset_id]),
          }

          sendHttpPostRequest(
            'exercise/api/oam_unmount_public_dataset/',
            data,
            (res) => {
              if (res.code == 0) {
                message.success('取消挂载成功~')
                queryExerciseInfo()
              } else {
                message.error(res.message)
              }
            }
          )
          setUnMountDatasetModalVis(false)
        }}
        width={460}
        open={unMountDatasetModalVis}
        setOpen={setUnMountDatasetModalVis}
        modalTitle={'提示'}
        modalContent={
          <div style={{ margin: '0 auto' }}>
            <Row align={'middle'} justify={'center'} style={{ width: '100%' }}>
              <Col>
                确定要取消挂载
                <span className={GlobalCss.hlText}>
                  {' '}
                  {actionDataset?.title}{' '}
                </span>
                吗？
              </Col>
            </Row>
          </div>
        }
      />
      <MountDatasetToTaskModal
        actionCallback={queryExerciseInfo}
        open={addDatasetModalVis}
        setOpen={setAddDatasetModalVis}
        exercise={exercise}
      />
    </Layout>
  )
}

export default OAMTaskEdit
